export default (password?: string) => password?.substr(0, 10);
